import ministryService from "../../../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      questions: [],
      loading: false,
      working: false,
    };
  },
  getters: {
    questions(state) {
      return state.questions;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    ngoQuestions(state) {
      return state.questions.filter(
        (el) => el.faqCategory && el.faqCategory.type === "interior"
      );
    },
    guestQuestions(state) {
      return state.questions.filter(
        (el) => el.faqCategory && el.faqCategory.type === "exterior"
      );
    },
    allQuestions(state) {
      return state.questions.filter(
        (el) => el.faqCategory && el.faqCategory.type === "both"
      );
    },
  },
  mutations: {
    setData(state, payload) {
      state.questions = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchQuestions({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchQuestions();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editQuestion({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.updateQuestion(payload);
        await dispatch("fetchQuestions");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async addQuestion({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.addQuestion(payload);
        await dispatch("fetchQuestions");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteQuestion({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        await ministryService.deleteQuestion(id);
        await dispatch("fetchQuestions");
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
